import { useQuery } from "@tanstack/react-query"

// useDebounce.js
import { useEffect } from "react";

import { useCombobox, useMultipleSelection } from "downshift"
import React, { useState } from "react"

export function ArtistsSelect({ defaultValue = [], onChange, name }) {
      const [inputValue, setInputValue] = React.useState('')
      const { data: artists, isLoading } = useQuery({ queryKey: [ '/api/artists?limit=6&q=' + inputValue ] })
      const [selectedItems, setSelectedItems] =
         React.useState(defaultValue)
      const items = artists?.data ?? []

      const { getSelectedItemProps, getDropdownProps, removeSelectedItem } =
         useMultipleSelection({
            selectedItems,
            onStateChange({ selectedItems: newSelectedItems, type }) {
               switch (type) {
                  case useMultipleSelection.stateChangeTypes
                     .SelectedItemKeyDownBackspace:
                  case useMultipleSelection.stateChangeTypes
                     .SelectedItemKeyDownDelete:
                  case useMultipleSelection.stateChangeTypes.DropdownKeyDownBackspace:
                  case useMultipleSelection.stateChangeTypes
                     .FunctionRemoveSelectedItem:
                     setSelectedItems(newSelectedItems)
                     break
                  default:
                     break
               }
            },
         })
      const {
         isOpen,
         getToggleButtonProps,
         getLabelProps,
         getMenuProps,
         getInputProps,
         highlightedIndex,
         getItemProps,
         selectedItem,
      } = useCombobox({
         items,
         itemToString(item) {
            return item ? item.name : ''
         },
         defaultHighlightedIndex: 0, // after selection, highlight the first item.
         selectedItem: null,
         inputValue,
         stateReducer(state, actionAndChanges) {
            const { changes, type } = actionAndChanges

            switch (type) {
               case useCombobox.stateChangeTypes.InputKeyDownEnter:
               case useCombobox.stateChangeTypes.ItemClick:
                  return {
                     ...changes,
                     isOpen: true, // keep the menu open after selection.
                     highlightedIndex: 0, // with the first option highlighted.
                  }
               default:
                  return changes
            }
         },
         onStateChange({
            inputValue: newInputValue,
            type,
            selectedItem: newSelectedItem,
         }) {
            switch (type) {
               case useCombobox.stateChangeTypes.InputKeyDownEnter:
               case useCombobox.stateChangeTypes.ItemClick:
               case useCombobox.stateChangeTypes.InputBlur:
                  if (newSelectedItem) {
                     setSelectedItems([...selectedItems, newSelectedItem])
                     setInputValue('')
                  }
                  break

               case useCombobox.stateChangeTypes.InputChange:
                  setInputValue(newInputValue)

                  break
               default:
                  break
            }
         },
      })

      return (
         <div className="">
            <div className="flex flex-col gap-1">
               <label className="w-fit" {...getLabelProps()}>
                  Pick some books:
               </label>
               {/* {JSON.stringify({inputValue, artists}, null, 2)} */}
               <div className="inline-flex gap-2 items-center flex-wrap p-1.5">
                  {selectedItems.map(function renderSelectedItem(
                     selectedItemForRender,
                     index,
                  ) {
                     return (
                        <span
                           className="bg-gray-100 rounded-md px-1 focus:bg-red-400"
                           key={`selected-item-${index}`}
                           {...getSelectedItemProps({
                              selectedItem: selectedItemForRender,
                              index,
                           })}
                        >
                           {selectedItemForRender.name}
                           <span
                              className="px-1 cursor-pointer"
                              onClick={e => {
                                 e.stopPropagation()
                                 removeSelectedItem(selectedItemForRender)
                              }}
                           >
                              &#10005;
                           </span>
                        </span>
                     )
                  })}
                  {isLoading && <p>Searching...</p>}
                  <div className="flex gap-0.5 grow">
                     <input
                        placeholder="Search artist"
                        className="w-full form-control"
                        {...getInputProps(getDropdownProps({ preventKeyAction: isOpen }))}
                     />
                     <button
                        aria-label="toggle menu"
                        className="px-2"
                        type="button"
                        {...getToggleButtonProps()}
                     >
                        &#8595;
                     </button>
                  </div>
               </div>
            </div>
            <ul
               className={`list-unstyled absolute w-inherit bg-white mt-1 shadow-md max-h-80 overflow-scroll p-0 z-10 ${!(isOpen && items?.length) && 'hidden'
                  }`}
               {...getMenuProps()}
            >
               {isOpen &&
                  items.map((item, index) => (
                     <li
                        className={[
                           highlightedIndex === index && 'bg-blue-300',
                           selectedItem === item && 'font-bold',
                           'py-2 px-0 border-b flex flex-col',
                        ].join(' ')}
                        key={item._id}
                        {...getItemProps({ item, index })}
                     >
                        <div class="d-flex">
                           <div class="flex-shrink-0">
                              <img src={item.images?.[0]} alt="" width={66} height={66} className="rounded-md object-cover " />
                           </div>
                           <div class="flex-grow-1 pl-3 ms-3">
                              <div>
                                 <div>{item.name} <i>{item.type}</i></div>
                                 <address className="">{item.address?.city}, {item.address?.country}</address>
                                 {/* <span className="text-sm text-gray-700">{item.author}</span> */}
                              </div>
                           </div>
                        </div>
                     </li>
                  ))}
            </ul>
         </div>
      )
   }


import { useId } from "react";
// import { useDebounce } from "./useDebounce";
// import { useFetchOptions } from "./useFetchOptions";
import api from "../services/axios";

export default function MultiSelectDropdown({ apiUrl, selected = [], onChange }) {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search);
  const popoverId = useId();

  const { data: { data: options } = {}, isLoading } = useFetchOptions(apiUrl, debouncedSearch);

  const toggleSelect = (item) => {
   alert('Selected '+item.name)
    if (selected?.some((s) => s._id === item._id)) {
      onChange && onChange(selected.filter((s) => s._id !== item._id));
    } else {
      onChange && onChange([...selected, item]);
    }
  };

  return (
    <div className="relative w-64">
      <button
        type="button"
        popovertarget={popoverId}
        className="border p-2 w-full text-left rounded flex flex-wrap gap-1"
      >
        {selected?.length > 0 ? (
          selected.map((s) => (
            <span
              key={s._id}
              className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-sm"
            >
              {s.name}
            </span>
          ))
        ) : (
          <span className="text-gray-500">Select...</span>
        )}
      </button>

      <div
        id={popoverId}
        popover="auto"
        className="border bg-white rounded shadow mt-1 w-64"
      >
        <div className="p-2 border-b">
          <input
            type="text"
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full border rounded p-1 text-sm"
          />
        </div>

        <div className="max-h-48 overflow-y-auto">
          {isLoading && <div className="p-2 text-gray-500">Loading...</div>}
          {!isLoading && options?.length === 0 && (
            <div className="p-2 text-gray-500">No results</div>
          )}
          {options?.map((opt) => (
            <div
              key={opt._id}
              onClick={() => toggleSelect(opt)}
              className={`p-2 cursor-pointer hover:bg-gray-100 ${
                selected?.some((s) => s._id === opt._id)
                  ? "bg-blue-50 text-blue-700"
                  : ""
              }`}
            >
              {opt.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export const useFetchOptions = (url, search = "") => {
  return useQuery({
    queryKey: ["options", url, search],
    queryFn: async () => {
      const { data } = await api.get(`${url}?limit=6&q=${encodeURIComponent(search)}`);
      return data;
    },
    enabled: !!url,
  });
};

export function useDebounce(value, delay = 400) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}

